import React, { Component } from 'react';
import { PropTypes, instanceOf } from 'prop-types';
import { connect } from 'react-redux';
import { withCookies, Cookies } from 'react-cookie';
import * as session_handlers from '../../actions/session_handler';
import Header from '../shared/Header';
import Content from './Content';
import Footer from '../shared/Footer';
import { LOGIN_TOKEN_TYPE_COOKIE,
    LOGIN_TOKEN_TYPE_SNAPCHAT,
    LOGIN_TOKEN_TYPE_BSAUTH
} from '../../constants/cookie_constants';

import './LoginView.css';


class LoginView extends Component {
    componentWillMount() {
        const { cookies } = this.props;

        const loginTokenType = cookies.get(LOGIN_TOKEN_TYPE_COOKIE);
        if(typeof loginTokenType !== 'undefined') {
            if (loginTokenType === LOGIN_TOKEN_TYPE_BSAUTH) {
                this.props.updateLoginSession(true, LOGIN_TOKEN_TYPE_BSAUTH);
            } else if (loginTokenType === LOGIN_TOKEN_TYPE_SNAPCHAT) {
                this.props.updateLoginSession(true, LOGIN_TOKEN_TYPE_SNAPCHAT);
            }
        }
    }

    render() {
        return (
            <div className="login-view">
                <Header />
                <Content />
                <Footer />
            </div>
        );
    }
}

LoginView.propTypes = {
    updateLoginSession: PropTypes.func.isRequired,
    cookies: instanceOf(Cookies).isRequired
};


export default connect(state => ({
    session: state.sessionReducer
}), session_handlers)(withCookies(LoginView));



// WEBPACK FOOTER //
// ./src/components/login_view/LoginView.js